<template>
  <div id="ras-app" class="ras-main">
    <SiteHeader v-if=" $route.path !== '/'" />
    <main @click="closeAbout" :class="['ras-wrapper', {
      'u-offset-header': $route.path !== '/', 
      'ras-wrapper--scroll': $route.path == '/results' || $route.path == '/genres',
      'ras-wrapper--home': $route.path == '/'
      }]">
      <transition mode="out-in" name="slide-left">
        <router-view/>
      </transition>
    </main>
    <transition name="slide">
      <About v-if="getAboutStatus" />
    </transition>
    <SiteFooter :share="true" />
  </div>
</template>

<script>
import SiteHeader from '@/components/Brand/Header.vue'
import SiteFooter from '@/components/Brand/Footer.vue'
import About from '@/components/About.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    SiteHeader,
    SiteFooter,
    About
  },
  computed: {
    ...mapGetters(['getAboutStatus'])
  },
  methods: {
    closeAbout() {
      if(this.getAboutStatus) {
        this.$store.dispatch('setAboutStatus', false)
      }
    },
  },
  metaInfo: {
    title: 'Let Netflix choose your next vacation | MyBaggage',
    meta: [
      { name: 'description', content: 'Decide your next vacation based on your latest binge. Take our quiz to find your next vacation destination using your Netflix preferences.' },
      { property: 'og:title', content: 'Let Netflix choose your next vacation | MyBaggage' },
      { name: 'og:description', content: 'Decide your next vacation based on your latest binge. Take our quiz to find your next vacation destination using your Netflix preferences.' },
      { property: 'og:url', content: 'https://www.mybaggage.com/jetflix-vacations/' },
      { property: 'og:image', content: '/images/jetflix-vacations-og-image.jpg' }
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.mybaggage.com/blog/jetflix-vacations/'
      }
    ]
  }
}
</script>

<style lang="scss">
body {
  margin: 0 !important;
  min-width: 0 !important;
}

.ras-wrapper {
  background-color: $black;
  width: 100vw;
  min-height: 100vh;
  transition: background ease .5s;
  overflow: hidden;

  @media (min-width: map_get($breakpoints, lg)) {
    height: 100vh;
  }

  &--scroll {
    height: auto;
    min-height: 100vh;
    width: 100%;
  }

  &--home {
    background-color: $c-home-background;
  }
}

.slide-leave-active,
.slide-enter-active {
  transition: .5s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(100%, 0);
}

.slide-left-leave-active,
.slide-left-enter-active {
  transition: .5s;
}
.slide-left-enter {
  transform: translate(100%, 0);
}
.slide-left-leave-to {
  transform: translate(-100%, 0);
}
</style>
